import AttachablePaymentMethod from './AttachablePaymentMethod';
import CashPaymentMethod from './CashPaymentMethod';
import PaymentMethodOption from './PaymentMethodOption';
import SavePaymentInfoConsent from './SavePaymentInfoConsent';
import TaxpayerDocumentPaymentMethod from './TaxpayerDocumentPaymentMethod';

export default {
  AttachablePaymentMethod,
  CashPaymentMethod,
  PaymentMethodOption,
  SavePaymentInfoConsent,
  TaxpayerDocumentPaymentMethod,
};
